module.exports = __webpack_public_path__ + "media/time-action-warning.ba56203b.mp3";